module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

if(gon.v2){ ;
__p += '\n\n<div class="photo_block" id="' +
((__t = ( id )) == null ? '' : __t) +
'" data-path-hover="M120,0c82.1,0,100.6,39.2,120,39.2c0,0.7,0,3.6,0,6.7c-23.6,0-194.8,0-240,0\n    c0-2.7,0-4.1,0-6.7C14,39.2,37.9,0,120,0z">\n\n    ';
if(currentAlbum.campaign){ ;
__p += '\n    ';
 if(!voted()){ ;
__p += '<div class="vote_button vote_container vote_text">' +
((__t = ( decode_utf8(getVoteShareText()) )) == null ? '' : __t);
 if(displayOptions.showVoteCount  &&  currentAlbum.campaign){ ;

 if(like_count != null && like_count != "null" && like_count){ ;
__p += ': ' +
((__t = ( like_count  )) == null ? '' : __t);
 };

 };
__p += '</div>';
 };
__p += '\n		';
 if(voted()){ ;
__p += '<div class="vote_button voted vote_container vote_text">' +
((__t = ( decode_utf8(getVotedText()) )) == null ? '' : __t) +
'</div>';
 };
__p += '\n    ';
 };
__p += '\n	';
 if (isVideo() && !gon.packery) {;
__p += '\n		<a class="layer_video lightboxed" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" rel=\'album\' href="' +
((__t = ( thumbnail() )) == null ? '' : __t) +
'">\n			<div class="play_button"></div>\n			<div class="play_cover"></div>\n		</a>\n	';
};
__p += '\n	';
 if (!gon.packery) {;
__p += '\n	<a class="grouped_elements img_holder image_anchor ';
 if (!isVideo() || gon.packery) {;
__p += 'lightboxed ';
};
__p += '" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" ';
 if (!isVideo()) {;
__p += 'href="' +
((__t = ( photoURL('xl') )) == null ? '' : __t) +
'" rel=\'album\'';
};
__p += ' style="background-image: url(&quot;' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'&quot;);"><img class="box_image" style="display:none;" src="' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'" /></a>\n	';
};
__p += '\n	';
 if (gon.packery) {;
__p += '\n	<a class="grouped_elements img_holder image_anchor ';
 if (!isVideo() || gon.packery) {;
__p += 'lightboxed ';
};
__p += '" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" ';
 if (!isVideo()) {;
__p += 'href="' +
((__t = ( photoURL('xl') )) == null ? '' : __t) +
'" rel=\'album\'';
};
__p += ' style="background-image: url(&quot;' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'&quot;); postition:relative; z-index: 2;"><img class="box_image" style="display:none;" src="' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'" /></a>\n	<a class="grouped_elements img_holder image_anchor inactivated ';
 if (!isVideo() || gon.packery) {;
__p += 'lightboxed ';
};
__p += '" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" ';
 if (!isVideo()) {;
__p += 'href="' +
((__t = ( photoURL('xl') )) == null ? '' : __t) +
'" rel=\'album\'';
};
__p += ' style="background-image: url(&quot;' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'&quot;); opacity:0; postition:relative; z-index:0"><img class="box_image" style="display:none;" src="' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'" /></a>\n	';
};
__p += '\n	<svg viewBox="0 -5 240 51" preserveAspectRatio="none">\n	  <path d="M120,45.9c82.1,0,100.6,0,120,0l0,0c-23.6,0-194.8,0-240,0l0,0C14,45.9,37.9,45.9,120,45.9z"/>\n  </svg>\n	<div class="social_holder">\n		<div class="pixlee_fshare social_button">\n		</div><div class="pixlee_tweet social_button">\n		</div><div class="pixlee_pinit social_button">\n		</div><div class="pixlee_tumblr social_button"></div>\n	</div>\n  <div class="image_info">\n      ' +
((__t = ( submitterAnchor(true) )) == null ? '' : __t) +
'\n      ';
 if (shouldShowCaptions()){;
__p += '\n      	<div class="photo_caption">';
 if (getTitle() != ""){;
__p += ' ' +
((__t = (  decode_utf8(getTitle()) )) == null ? '' : __t) +
' ';
 };
__p += '</div> \n      	';
 if (showDate()){;
__p += '<i>' +
((__t = (  getDate() )) == null ? '' : __t) +
'</i>';
 };
__p += '\n      ';
 };
__p += '\n  </div>\n  ';
 if (!_.isFalsy(gon.display_options.customCallToActionLink)) { ;
__p += '\n  	<a href="' +
((__t = ( decodeURIComponent(gon.display_options.customCallToActionLink) )) == null ? '' : __t) +
'" target="_top" class="custom_call_to_action_anchor" style="font-size:0px">call to action link</a>\n  ';
 } ;
__p += '\n  ';
 if (!_.isFalsy(action_link)) { ;
__p += '\n  	<a href="' +
((__t = ( decodeURIComponent(action_link) )) == null ? '' : __t) +
'" target="_top" class="custom_call_to_action_anchor" style="font-size:0px">call to action link</a>\n  ';
 } ;
__p += '\n</div>    \n';
 };
__p += '\n\n';
if(!gon.v2){ ;
__p += '\n<div class="box" id="' +
((__t = ( id )) == null ? '' : __t) +
'">\n	';
if(currentAlbum.campaign){ ;
__p += '\n		<a class="share_panel_button_w_vote"></a>\n	';
};
__p += '\n		';
 if (isVideo()) {;
__p += '\n			<a class="layer_video lightboxed" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" rel=\'album\' href="' +
((__t = ( thumbnail() )) == null ? '' : __t) +
'">\n				<div class="play_button"></div>\n				<div class="cover"></div>\n			</a>\n		';
};
__p += '\n		<div class="layer_photo_caption">\n			<a class="grouped_elements img_holder image_anchor ';
 if (!isVideo()) {;
__p += 'lightboxed ';
};
__p += '" id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'" ';
 if (!isVideo()) {;
__p += 'href="' +
((__t = ( photoURL('xl') )) == null ? '' : __t) +
'" rel=\'album\'';
};
__p += '>\n				\n				<div class="box_bg_image" style="background-image: url(&quot;' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'&quot;);" ></div>\n				<img class="box_image" style="display:none;" src="' +
((__t = ( thumbnail('medium') )) == null ? '' : __t) +
'" />\n			</a>\n			';
 if(!voted()){ ;
__p += '<div class="vote_container">';
 };
__p += '\n			';
 if(voted()){ ;
__p += '<div class="vote_container voted">';
 };
__p += '\n					<div class="vote_button"><svg version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\nwidth="160px" height="30px" viewBox="0 0 160 30" enable-background="new 0 0 160 30" xml:space="preserve"><path d="M1.729,29.969c0,0,2.312,0.125,4.062-2l20.75-25.312c0,0,1.781-2.312,4.781-2.312h97.062\nc0,0,2.72,0,4.828,2.688l19.531,24.266c0,0,1.969,2.688,4.547,2.703l0,0l0,0l0,0l0,0l0,0l0,0L1.729,29.969z"/>';
 if(!voted()){ ;
__p += '<span class="vote_text">' +
((__t = ( decode_utf8(getVoteShareText()) )) == null ? '' : __t);
 if(displayOptions.showVoteCount  &&  currentAlbum.campaign){ ;
__p += '<span class="vote_counter">';
 if(like_count != null && like_count != "null" && like_count){ ;
__p += ': ' +
((__t = ( like_count  )) == null ? '' : __t) +
'</span>\n						';
 };
__p += '\n						';
 };
__p += '\n						</span>';
 };
__p += '\n						';
 if(voted()){ ;
__p += '<span class="vote_text">Voted</span>';
 };
__p += '\n						</svg>\n					</div>\n				</div>\n				\n					<div class="caption">\n						<div class="caption-wrapper"><span>' +
((__t = ( submitterAnchor(true) )) == null ? '' : __t) +
'</span>';
 if (shouldShowCaptions()){;

 if (getTitle() != ""){;
__p += '\n							<div class="item_caption_text"> ' +
((__t = (  decode_utf8(getTitle()) )) == null ? '' : __t) +
' </div> \n							\n						';
 };

 };

 if (showDate()){;
__p += '<i>' +
((__t = (  getDate() )) == null ? '' : __t) +
'</i>';
 };
__p += '</div>\n					</div>\n				\n		</div>\n		<div class="layer_share">\n			<div class="close_share_button"></div>\n			<div class="pixlee_share">\n				<span>Share this photo</span>\n				<div class="pixlee_fshare"></div>\n				<div class="pixlee_tweet"></div>\n				<div class="pixlee_pinit"></div>\n				<div class="pixlee_tumblr"></div>\n			</div>\n		</div>\n	</div>\n\n';
 };
__p += '\n';

}
return __p
}